import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'twitterContent'
})
export class TwitterContentPipe implements PipeTransform {

  transform(value: any, args?: any): any {


    let content = (value.content) ? value.content  : (value.eventDescription) ? value.eventDescription : (value.description) ? value.description : 'mycoop';
    content = content.replace(/&nbsp;/g, '');
    var wrapper = document.createElement('div');
    wrapper.innerHTML = content;
    content = wrapper.innerText;
    if(content.length > 150){
      content = content.slice(0, 150)+'...'
    }
    content = value.residentId.firstName+ ' '+value.residentId.lastName+ ' said \"'+content+'\"'+'\r\n\r\n'+'Sign up and join your building on mycoop'
    
    return content;
    
  }

}
